// import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navigation from '../components/Navigation';
// import Loader from '../components/Loader'; 
import Footer from '../components/Footer';
import { footerEn } from '../data/footer';
import { navigationTop, navigationButtom } from '../params';
import { Link } from 'react-router-dom';
import CitiInner from '../components/Compliance/CITIInner';
import CitiOverview from '../components/Compliance/CitiOverview';
// import '../assets/scss/CoreLabsAboutUs.scss';
// import '../assets/scss/Articles.scss';
// import 'bootstrap/dist/css/bootstrap.min.css'; 




const navigationIntern = []

const crumb = [
  // { link: '//', text: 'Home' },
  { link: '//', text: 'Home' },

  { link: '/research/research-training', text: 'Research Training' },
  { link: '/research/research-training/CITI', text: 'Collaborative Institutional Training Initiative (CITI)' },



]



function Citi(props) {
  document.title = 'Collaborative Institutional Training Initiative (CITI)'
  const poster = '/uploads/core-labs.png'
  //const src = '/uploads/welcome.mp4'
  const headerData = {
    title: 'Collaborative Institutional Training Initiative (CITI)',
    crumb: crumb,
    navigationButtom: navigationButtom,
    navigationTop: navigationTop,
    applicationLinks: [{ text: 'Apply now', class: 'bordred', link: '/header/applynow' }],
  }


  
  return (
    <>
      <Navigation
        navigationIntern={navigationIntern}
        {...headerData}
        updateLang={props.updateLang}
      />
      <section className="space-block-60">
        <div className='container'>
            <div className='row-listing'>
                <CitiOverview/>
                <CitiInner/>
            </div>

          {/* <div className="d-flex justify-content-center">
              <Loader />
          </div> */}
        </div>
      </section>
      <Footer {...footerEn} />
    </>
  )
}

export default Citi;
